import { makeStyles } from '@material-ui/core/styles'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import clsx from 'clsx'
import React, { useContext } from 'react'

import TicketVariantContext, { TicketVariant } from '../../lib/TicketVariantContext'
import BenefitItem, { BenefitItemProps } from './BenefitItem'

const useStyles = makeStyles(theme => ({
  icon: {
    alignSelf: 'center',
    margin: 'auto',
  },
  included: {},
  promoted: {
    '&$included': {
      color: theme.palette.secondary.contrastText,
    },
    color: 'rgba(0, 0, 0, 0.3)',
  },
  root: {
    display: 'flex',
    textAlign: 'center',
  },
  standard: {
    '&$included': {
      color: theme.palette.secondary.main,
    },
    color: theme.palette.grey[500],
  },
}))

export type BenefitAvailabilityItemProps = BenefitItemProps & {
  included: boolean
}

const BenefitAvailabilityItem = ({
  className,
  included,
  ...rest
}: BenefitAvailabilityItemProps) => {
  const { variant } = useContext(TicketVariantContext)
  const classes = useStyles()
  const Icon = included ? CheckIcon : ClearIcon

  return (
    <BenefitItem
      className={clsx(
        classes.root,
        {
          [classes.standard]: variant === TicketVariant.Standard,
          [classes.promoted]: variant === TicketVariant.Promoted,
          [classes.included]: included,
        },
        className
      )}
      {...rest}
    >
      <Icon className={classes.icon} />
    </BenefitItem>
  )
}

export default BenefitAvailabilityItem
